import * as React from 'react';

const SvgComment = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.25C14.8325 18.25 18.75 14.3325 18.75 9.5C18.75 4.66751 14.8325 0.75 10 0.75C5.16751 0.75 1.25 4.66751 1.25 9.5C1.25 11.2005 1.7351 12.7878 2.57448 14.1308L0 18.25L6.87848 17.6768C7.84802 18.0471 8.90032 18.25 10 18.25Z", fill: "white" }));

export { SvgComment as default };
//# sourceMappingURL=Comment.svg.js.map
